import {
  getActivityVideoMediaId,
  getAssessmentVideoMediaId,
} from './resolve-youtube-media-id'

export const sanitizeFilename = name =>
  String(name || 'activity-plan')
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase()

const appendSection = (lines, title, value) => {
  if (!title || !value) {
    return
  }

  lines.push(title)
  lines.push(value)
  lines.push('')
}

export const formatActivityDownload = hit => {
  const lines = [hit.title, '']

  appendSection(
    lines,
    'Time required',
    [
      hit.details?.setupDuration != null
        ? `Setup time: ${hit.details.setupDuration} minutes`
        : null,
      hit.details?.durationMins != null
        ? `Duration: ${hit.details.durationMins} minutes`
        : null,
    ]
      .filter(Boolean)
      .join('\n'),
  )

  appendSection(lines, 'Summary', hit.details?.summary)
  appendSection(lines, 'Equipment', hit.details?.equipment)
  appendSection(lines, 'Setup', hit.details?.setup)
  appendSection(lines, 'Instructions', hit.details?.detail)
  appendSection(
    lines,
    hit.details?.assessmentTitle,
    hit.details?.assessmentText,
  )

  const activityVideoId = getActivityVideoMediaId(hit)
  const assessmentVideoId = getAssessmentVideoMediaId(hit)

  if (activityVideoId) {
    appendSection(
      lines,
      'Video',
      `https://www.youtube.com/watch?v=${activityVideoId}`,
    )
  }

  if (assessmentVideoId) {
    appendSection(
      lines,
      'Assessment video',
      `https://www.youtube.com/watch?v=${assessmentVideoId}`,
    )
  }

  return lines.join('\n').trim()
}

export const formatLessonPlanDownload = (planHit, activityHitsById = {}) => {
  const lines = [planHit.title, '']

  if (planHit.totalDurationMins != null) {
    appendSection(
      lines,
      'Total duration',
      `${planHit.totalDurationMins} minutes`,
    )
  }

  const sections = planHit.sections || []

  sections.forEach(section => {
    lines.push(section.name)
    lines.push('')
    ;(section.activities || []).forEach(activityId => {
      const activity = activityHitsById[activityId]
      if (!activity) {
        lines.push(`- Activity ${activityId}`)
        lines.push('')
        return
      }

      lines.push(activity.title)
      appendSection(lines, 'Summary', activity.details?.summary)
      appendSection(lines, 'Equipment', activity.details?.equipment)
      appendSection(lines, 'Setup', activity.details?.setup)
      appendSection(lines, 'Instructions', activity.details?.detail)

      const activityVideoId = getActivityVideoMediaId(activity)

      if (activityVideoId) {
        appendSection(
          lines,
          'Video',
          `https://www.youtube.com/watch?v=${activityVideoId}`,
        )
      }

      lines.push('')
    })
  })

  return lines.join('\n').trim()
}

export const downloadTextFile = (filename, content) => {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

export const downloadActivity = hit => {
  downloadTextFile(
    `${sanitizeFilename(hit.title)}.txt`,
    formatActivityDownload(hit),
  )
}

export const downloadLessonPlan = (planHit, activityHits) => {
  const activityHitsById = activityHits.reduce((map, hit) => {
    map[hit.objectID] = hit
    return map
  }, {})

  downloadTextFile(
    `${sanitizeFilename(planHit.title)}.txt`,
    formatLessonPlanDownload(planHit, activityHitsById),
  )
}
